export const WISHLIST_CHANGED = 'WISHLIST_CHANGED';
export const WISHLIST_PRODUCT_ADDED = 'WISHLIST_PRODUCT_ADDED';
export const WISHLIST_PRODUCT_DELETED = 'WISHLIST_PRODUCT_DELETED';
export const WISHLIST_ALL_PRODUCTS_DELETED = 'WISHLIST_ALL_PRODUCTS_DELETED';
